import React from 'react';
import PreviousPageIcon from '@common/components/icons/PreviousPageIcon';
import NextPageIcon from '@common/components/icons/NextPageIcon';
import * as styles from './index.module.css';

const Pagination = React.memo(
  ({
    pageIndex,
    pageSize,
    pageSizeOptions,
    totalCount,
    canPreviousPage,
    canNextPage,
    onPageSizeChange,
    onPreviousPage,
    onNextPage,
  }) => {
    const handlePageSizeChange = (e) => {
      onPageSizeChange(Number(e.target.value));
    };

    return (
      <div className={styles['pagination-container']}>
        <div className={styles['pagination-controls']}>
          <div className={styles['page-size-container']}>
            <label htmlFor="pageSize" className={styles['page-size-label']}>
              Rows per page{' '}
              <select
                id="pageSize"
                value={pageSize}
                onChange={handlePageSizeChange}
                className={styles['page-size-select']}
                aria-label="Select number of rows per page"
              >
                {pageSizeOptions.map((size) => (
                  <option key={size} value={size}>
                    {size}
                  </option>
                ))}
              </select>
            </label>
          </div>
          <div className={styles['pagination-buttons-container']}>
            <button
              type="button"
              disabled={!canPreviousPage}
              onClick={onPreviousPage}
              className={styles['pagination-button']}
              aria-label="Previous page"
            >
              <PreviousPageIcon />
            </button>
            <button
              type="button"
              className={styles['current-page-button']}
              aria-label={`Current page ${pageIndex}`}
            >
              {pageIndex}
            </button>
            <button
              type="button"
              disabled={!canNextPage}
              onClick={onNextPage}
              className={styles['pagination-button']}
              aria-label="Next page"
            >
              <NextPageIcon />
            </button>
          </div>
        </div>
        <div className={styles['page-info']}>
          <span>
            {(pageIndex - 1) * pageSize + 1}-
            {Math.min(pageIndex * pageSize, totalCount)} of {totalCount}
          </span>
        </div>
      </div>
    );
  },
);

export default Pagination;

